function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M48.227 93.55L160.04 32.07l-39.227-21.588L9 71.963l39.227 21.588z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M14.87 73.057l107.812-59.214-2.221-1.09-107.81 59.21 2.22 1.094zM48.437 91.426l107.812-59.21-2.222-1.095-107.81 59.213 2.22 1.092z",
  clipRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "kh60bj5bpa",
  width: 40,
  height: 82,
  x: 9,
  y: 71,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9 71.963v58.764l39.227 21.569V93.551L9 71.963z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#kh60bj5bpa)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  d: "M9 71.963v58.764l39.227 21.569V93.551L9 71.963z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  d: "M27 79.094h-2v74.33h2v-74.33z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M112.059 67.908L81.754 84.573l-4.558 5.686 34.863-19.165v-3.186zM112.059 62.292L89.076 75.164 84.52 80.85l27.538-15.37v-3.188z",
  clipRule: "evenodd"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M48.227 93.436v58.86L160.04 90.832V31.956L48.227 93.435z",
  clipRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M56.662 92.44l-1.45.797v51.425l1.45-.798V92.44zM64.156 88.872l-1.45.8v51.423l1.45-.798V88.872zM71.156 85.06l-1.45.8v51.423l1.45-.798V85.06zM78.156 80.296l-1.45.8v51.422l1.45-.798V80.296zM85.379 76.612l-1.452.796v51.424l1.452-.796V76.612zM91.87 73.044l-1.447.798v51.423l1.448-.796V73.044zM98.796 69.338l-1.452.798v51.423l1.452-.796V69.338zM105.288 65.77l-1.447.798v51.425l1.447-.798V65.77zM112.341 61.634l-1.451.798v51.424l1.451-.797V61.634zM118.833 58.066l-1.451.798v51.425l1.451-.798V58.066zM126.833 54.255l-1.451.797v51.425l1.451-.798V54.254zM133.833 49.49l-1.451.798v51.424l1.451-.797V49.49zM140.833 45.678l-1.451.798V97.9l1.451-.798V45.678zM148.419 42.386l-1.451.798V94.61l1.451-.798V42.386zM155.912 37.866l-1.452.798v51.424l1.452-.797V37.866z",
  clipRule: "evenodd"
});

function SvgSpaceContainer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 162,
    fill: "none",
    viewBox: "0 0 170 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceContainer);
export default __webpack_public_path__ + "static/media/spaceContainer.b7e1f8ce.svg";
export { ForwardRef as ReactComponent };